import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { EARNING, PAGE_LIMIT } from "helpers/viewContent";
import ReactPagination from "components/shared/ReactPagination";
import { FORMAT_TEXT, DATE_FORMAT_TIME } from "helpers/common";
import ContentLoader_ from "helpers/ContentLoader_";

//imported
import * as actions from 'store/actions/index.js';
import * as Path from "routes/paths";
import { getList_} from "store/services/commonService";

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount }) => {
  //pagination
  const [activePage, setActivePage] = useState(1);
  const [filter, setFilter] = useState({
    page: activePage,
    limit: PAGE_LIMIT,
  });

  const [listing, setListing] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    try {
      let query = {
        url: "earning/list",
        page: activePage,
        limit: PAGE_LIMIT,
        common: false,
        search_string: "",
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: false }));
      let res = await dispatch(getList_(query));
      setListing(res?.body?.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [activePage]);

  //pagination
  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Helmet title={EARNING.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-wallet menu-icon"></i>
          </span>{" "}
          {EARNING.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.earning}>{EARNING.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <div className="row">
                  <div className="col-md-6">Listing</div>
                  <div className="col-md-4"></div>
                </div>
              </h4>
              <div class="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th> Earning Date </th>
                      <th> Earning From</th>
                      <th> Earning </th>
                      <th> Payment Method </th>
                      <th> Payment Status </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <div className="loader-class">
                         <ContentLoader_ />
                     </div>
                    ) : (
                    <tbody>
                    <>
                    {listing?.length > 0 &&
                      listing.map((list, i) => {
                        return (
                          <tr key={i}>
                            <td className="py-1">
                              {list?.date ? DATE_FORMAT_TIME(list?.date) : "N/A"}
                            </td>
                            <td>{list.user?.name ? FORMAT_TEXT(list.user?.name) : 'N/A'}</td>
                            <td>{list.total_amount ? `$ ${list.total_amount}` : 'N/A'}</td>
                            <td>{`${list?.payment_method === 0 ? 'Card' : list.payment_method === 1 ? 'Wallet' : 'Cash'}`}</td>
                            <td>{list.payment_status ? list.payment_status : 'N/A'}</td>
                            <td>
                              <Link to={`${Path.earningview}/${list?.id}`}>
                                <label
                                  className="btn btn-sm btn btn-gradient-info"
                                  style={{ cursor: "pointer" }}
                                  title="View"
                                >
                                  <i className="mdi mdi-eye"></i>
                                </label>
                              </Link>
                            </td>
                          </tr>
                        );
                      })}
                      </>
                    </tbody>
                    )}
                </table>
              </div>
              {listing.length > 0 && (
                <div className="pagination-box-review">
                  <ReactPagination
                    activePage={activePage}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    handlePageChange={handlePageChange}
                  />
                </div>
              )}
              {listing.length == 0 && (
                <div className="row">
                  <div className="col-md-6 pt-5">
                    <span>No data found...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Common.itemsCountPerPage,
    totalItemsCount: state.Common.totalItemsCount,
    loader: state.Common.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
